import { JSONContent } from '@tiptap/core';

import { includesReadonlyPlaceholder, Settings } from './richtext.utils';
import { READONLY_PLACEHOLDER_NODE } from './richtext-custom-extensions';

export function getInitialContent({
  initialValue,
  settings,
}: {
  settings: Settings;
  initialValue: JSONContent | null | undefined;
}) {
  const doc: {
    type: 'doc';
    content: JSONContent[];
  } = {
    type: 'doc',
    content: [],
  };

  if (
    settings.readonlyPlaceholder &&
    !includesReadonlyPlaceholder(initialValue || undefined)
  ) {
    doc.content.push({
      type: 'paragraph',
      content: [
        {
          type: READONLY_PLACEHOLDER_NODE,
          attrs: {
            text: `${settings.readonlyPlaceholder} `,
          },
        },
      ],
    });
  }

  if (initialValue?.content) {
    doc.content = doc.content.concat(initialValue.content);
  }

  return doc.content.length > 0 ? doc : undefined;
}
